jQuery(document).ready(function($) {
  
	var flag = false;

	// open leaders overlay
	$('.leader-info').on('click', function() {
		flag = true;
		$('body').css('overflow', 'hidden');
		$(this).parent().find('.leaders-overlay').fadeIn();
	});


	// close leaders overlay
	$('.close-leaders-overlay').on('click', function() {
		flag = false;
		$('.leaders-overlay').fadeOut();
		$('body').css('overflow', 'visible');
	});


	// leader box on mouse enter
	$('.leader').on('mouseenter', function() {
		if (!flag) {
			$(this).find('.leader-name').addClass('hide-name');
			$(this).find('.leader-info').addClass('show-leader');
			$(this).find('.main-image').fadeOut();
		}
	});


	// leader box on mouse leave
	$('.leader').on('mouseleave', function() {
		if (!flag) {
			$(this).find('.leader-name').removeClass('hide-name');
			$(this).find('.leader-info').removeClass('show-leader');
			$(this).find('.main-image').fadeIn();
		}
	});


	// find all links that have a _blank target
	$('a[target="_blank"]').each(function() {
		var innerText = $(this).text();
		if(!innerText.length) {
		  if($(this).find('img').length) {
			innerText = $(this).find('img').attr('alt');
		  }
		}
		if(!innerText.length) {
		  innerText = 'Link';
		}
		$(this).attr('aria-label', innerText + ' - Opens in a New Window or Tab');
	  });


	// trim leader button to only display the first name
	var btnText = $('.leader-info button span');
	$.each(btnText, function(i, e) {
		var splitText = $(e).text().split(' ')[0];
		$(this).text(splitText);
	});

	
	// When on the locations view, check for empty links.
	// If an empty links exists, hide them from the user.
	var links = $('.location-info-box').find('a');
	$.each(links, function(i, e) {
		var singleLink = $(e).attr('href');
		var locationName = $(this).parent().find('.location-name').text();
		if (!singleLink.length) {
			$(this).hide();
		}

		// Depending on the location, show the apply button and
		// set the href to a custom page with a form.
		if (locationName === 'Brussels, Belgium') {
			// $(this).parent().find('.resume-upload').addClass('show').attr('href', '/brussels-resume-form');
			$(this).parent().find('.submit-resume').hide();
		} else if (locationName === 'Veendam, The Netherlands') {
			// $(this).parent().find('.resume-upload').addClass('show').attr('href', '/veendam-resume-form');
			// $(this).parent().find('.submit-resume').hide();
		}
	});

	
	// Mobile menu controls to expand the canvas to be 100% width
	// when the mobile menu icon is clicked.
	$('.menu-icon').on('click', function() {
		$('#off-canvas').addClass('grow-canvas');
	});

	
	// close nav 
	function closeNav() {
		$('#off-canvas').removeClass('grow-canvas');
		$('.off-canvas').removeClass('is-open').addClass('is-closed');
		$('.js-off-canvas-overlay').removeClass ('is-visible is-closable');
		$('.off-canvas-content').removeClass('is-open-right has-transition-push has-position-right');
	};


	// When you click the mobile close button we need to remove a 
	// number of classes applied when clicking the mobile nav icon.
	$('.mobile-close').on('click', function() {
		closeNav();
	});


	// Fire close nav function when clicking on menu item
	$('#offcanvas-nav li a').on('click', function() {
		// Create a hack for when clicking our people on pages other than home.
		// For some reason without it the link won't work and stays on the 
		// current page the user is on.
		if (window.location.pathname !== '/') {
			if ($(this).text() === 'Our People') {
				window.location = '/#our-people';
			}
		}
		
		closeNav();
	});


	// When clicking on a homepage location, send the user to the locations
	// page and scroll down to the location they clicked on via homepage.
	$('.location').each(function() {
		var name = $(this).find('.location-name').text();
		var anchor = $(this).parent();
		anchor.attr('href', '/locations/#' + name);
	});

	
	// When clicking on a news article, prevent the page from going to the 
	// post single page and instead show the post details in a lightbox.
	// $('.news-section .wp-block-latest-posts__featured-image + a').on('click', function(e) {
	// $('.news-post a').on('click', function(e) {
	// 	e.preventDefault();

	// 	var parent = $(this).parent().parent().parent().parent();
	// 	var closeBtn = $('<div class="close-news">x</div>');
	// 	var parentSrc = parent.find('img').attr('src');
	// 	var img = $('<img src="">').attr('src', parentSrc).attr('class', 'box-img');
	// 	var title = $('<h3></h3>').text(parent.find('.news-post h2').text()).attr('class', 'box-heading');
	// 	var contentBox = $('<div class="content-box"></div>');
	// 	$('.content-wrap').append(contentBox);
	// 	var pullQuote = $('<p class="pq"></p>').text($(this).parent().parent().parent().find('.pull-quote').text());
	// 	var content = $(parent).find('.wp-block-group').html();
	// 	var copy = $('<div class="test"></div>').html(content);

	// 	$(contentBox).append(img);
	// 	$(contentBox).append(title);

	// 	if ($(this).parent().parent().parent().find('.pull-quote').text().length) {
	// 		$(contentBox).append(pullQuote);
	// 	}
		
	// 	$(contentBox).append(copy);

	// 	$('body').css('overflow', 'hidden');
	// 	$('.content-wrap').append(closeBtn);
	// 	$('.content-wrap').fadeIn();
	// });


	// // Close news overlay and remove appended content so elements do not
	// // duplicate when clicking on other news boxes.
	// $(document).on('click', '.close-news', function() {
	// 	$('.content-wrap').fadeOut(200, function() {
	// 		$('body').css('overflow', 'visible');
	// 		$('.pq').remove();
	// 		$('.content-box').remove();
	// 		$('.box-heading').remove();
	// 		$('.close-news').remove();
	// 		$('.box-img').remove();
	// 	});
	// });

});